import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Icon1 from '../images/icon1.png';
import Icon2 from '../images/icon2.png';
import Icon3 from '../images/icon3.png';
import Icon4 from '../images/icon4.png';
import Logo from '../images/nexxuslogo.png';
import '../styles/Page1.css';


export function Page1() {
    return (
        <Grid container spacing={0} sx={{ minHeight: '100vh' }}> {/*Contenedor principal, fondo de pantalla */}
            {/*codigo para version de desktop */}
            <Grid container spacing={2} sx={{ mt: "30px", mx: "auto", px: "50px", display: { xs: 'none', md: 'block' } }} className='prevent-overflow'>

                {/* Grid principal que contiene todo */}
                <Grid container spacing={2} size={{ xs: 12, md: 12 }}>

                    {/* Parte izquierda: logo y parrafos */}
                    <Grid size={{ xs: 12, md: 8 }}>

                        {/* Logo Nexxus */}
                        <Box component='img' src={Logo} alt='Logo Nexxus' className="logo-nexxus" />

                        {/* Parrafo principal */}
                        <Box p={2} mt={4}>
                            <Typography variant='h4' color="#DDDED9" align='justify'>
                                Big Data optimization and Centralization of information in the
                                cloud provides innovative solutions for managing and alanyzing
                                large volumes of data in the aerospace industry, which can
                                help airlines improve operational efficiency strategic
                                decision-making, and customer experience
                            </Typography>
                        </Box>

                        {/* Parrafo final */}
                        <Box p={2} mt={4}>
                            <Typography variant='h4' color="#DDDED9" align='justify'>
                                ODS brings together multiple decades of knowledge in the
                                aerospace industry and deep expertise in technology to
                                create a data platform that serves as Operational Data
                                Storage for airline data, supporting Digital Channels, Big Data,
                                and Analytics platforms to consolidate all data and support
                                current analysis and reporting needs.
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Parte derecha: Context */}
                    <Grid size={{ xs: 12, md: 4 }} sx={{ borderLeft: '10px solid #A2D6F8' }}>
                        <Box>
                            <Typography variant='h3' component='h3' color='white' align='center'>Context</Typography>
                        </Box>
                        <Box p={1}>
                            <Typography variant='h1' component='h1' color='#A2D6F8' align='center' sx={{ fontWeight: 'bold' }}>+80K</Typography>
                            <Typography variant='h4' component='h4' color='white' align='left' pl={2}>
                                Weekly average flights per day worldwide
                            </Typography>
                        </Box>
                        <Box p={1}>
                            <Typography variant='h1' component='h1' color='#A2D6F8' align='center' sx={{ fontWeight: 'bold' }}>+85%</Typography>
                            <Typography variant='h4' component='h4' color='white' align='left' pl={2}>
                                Of all data generated globally is considered unestructured
                            </Typography>
                        </Box>
                        <Box p={1}>
                            <Typography variant='h1' component='h1' color='#A2D6F8' align='center' sx={{ fontWeight: 'bold' }}>
                                2.5 quin<br />tillion
                            </Typography>
                            <Typography variant='h4' component='h4' color='white' align='left' pl={2}>
                                Bytes worth of data are generated each day
                            </Typography>
                        </Box>
                    </Grid>

                </Grid>


                <Grid container spacing={2} sx={{ mt: 10, px: 4, }}>
                    {/* Fila 1 */}
                    <Grid container spacing={2} alignItems="center" sx={{ mb: 6 }}>
                        <Grid size={{ md: 2 }} sx={{ textAlign: 'center' }}>
                            <Box
                                component="img"
                                src={Icon1}
                                alt="Icon 1"
                                sx={{
                                    width: { xs: '90px', sm: '120px', md: '140px' },
                                    height: 'auto',
                                    mx: 'auto',
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 10 }} sx={{ pl: '50px' }}>
                            <Typography variant="h3" component="h3" color="white" sx={{ fontWeight: 'bold' }}>
                                Ingestion
                            </Typography>
                            <Typography variant="h4" component="p" color="#DDDED9" align="justify" sx={{ mt: 1 }}>
                                Allows for data in different formats and delivery channels with fewer
                                restrictions. The design principles combine both operational and analytical
                                needs whereby the same data feeds populate both the data lake and operational
                                data store in a historic and auditable way.
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Fila 2 */}
                    <Grid container spacing={2} alignItems="center" sx={{ mb: 6, width: '100%' }}>
                        <Grid size={{ md: 2 }} sx={{ textAlign: 'center' }}>
                            <Box
                                component="img"
                                src={Icon2}
                                alt="Icon 2"
                                sx={{
                                    width: { md: '140px' },
                                    height: 'auto',
                                    mx: 'auto',
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 9 }} sx={{ pl: '50px', width: '100%' }}>
                            <Typography variant="h3" component="h3" color="white" sx={{ fontWeight: 'bold' }}>
                                Processing & transformation
                            </Typography>
                            <Typography variant="h4" component="p" color="#DDDED9" sx={{ mt: 1, width: '100%', maxWidth: '100%' }}>
                                Add new ways of data enrichment that will add greater value to the data.
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Fila 3 */}
                    <Grid container spacing={2} alignItems="center" sx={{ mb: 6 }}>
                        <Grid size={{ md: 2 }} sx={{ textAlign: 'center' }}>
                            <Box
                                component="img"
                                src={Icon3}
                                alt="Icon 3"
                                sx={{
                                    width: { xs: '100px', sm: '140px', md: '170px' },
                                    height: 'auto',
                                    mx: 'auto',
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 10 }} sx={{ pl: '50px' }}>
                            <Typography variant="h3" component="h3" color="white" sx={{ fontWeight: 'bold' }}>
                                Delivery
                            </Typography>
                            <Typography variant="h4" component="p" color="#DDDED9" align="justify" sx={{ mt: 1 }}>
                                Add new ways of delivering data to the client’s systems (Data Lake access
                                sharing, API connectivity) all in a controlled way with the Airline admins
                                having the option to manage each delivery channel directly.
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Fila 4 */}
                    <Grid container spacing={2} alignItems="center">
                        <Grid size={{ md: 2 }} sx={{ textAlign: 'center' }}>
                            <Box
                                component="img"
                                src={Icon4}
                                alt="Icon 4"
                                sx={{
                                    width: { xs: '90px', sm: '120px', md: '140px' },
                                    height: 'auto',
                                    mx: 'auto',
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 10 }} sx={{ pl: '50px' }}>
                            <Typography variant="h3" component="h3" color="white" sx={{ fontWeight: 'bold' }}>
                                Security
                            </Typography>
                            <Typography variant="h4" component="p" color="#DDDED9" align="justify" sx={{ mt: 1 }}>
                                Single sign-on and data sharing rule / role-based access. Some core functions
                                of our product are cybersecurity, continuous backup, data availability, Cloud
                                Watch and Auditability.
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>


            </Grid>

            {/*Codigo para movil */}

            <Grid container spacing={2} sx={{ display: { xs: 'flex', md: 'none' }, mt: "80px", overflowX: 'hidden' }}>
                {/* Logo Nexxus */}
                <Grid size={{ xs: 12 }} display={'flex'} justifyContent={'center'}>
                    <Box
                        component='img'
                        src={Logo}
                        alt='Logo Nexxus'
                        className='logo-nexxus'
                        sx={{ display: 'flex', mx: 'auto', justifyContent: 'center' }}
                    />
                </Grid>

                {/* Primer párrafo */}
                <Grid size={{ xs: 12 }}>
                    <Box p={2}>
                        <Typography variant='h5' color="#DDDED9" align='justify' className='text-h4'>
                            Big Data optimization and Centralization of information in the
                            cloud provides innovative solutions for managing and analyzing
                            large volumes of data in the aerospace industry, which can
                            help airlines improve operational efficiency strategic
                            decision-making, and customer experience
                        </Typography>
                    </Box>
                </Grid>

                {/* División de 6 y 6 para About Optimen y Context */}
                <Grid container spacing={2} size={{ xs: 12 }} alignItems="center" >

                    <Grid size={{ xs: 12 }} >
                        <Typography variant='h4' color='white' align='center' className='text-h3' p={1}>Context</Typography>
                        <Box sx={{ borderLeft: '10px solid #A2D6F8' }} mt={2}>
                            <Grid container alignItems="center" >
                                <Grid size={{ xs: 2 }} ml={2}>
                                    <Typography variant='h5' color='#A2D6F8' align='center' sx={{ fontWeight: 'bold' }} className='text-h2' p={1} >+80K</Typography>
                                </Grid>
                                <Grid size={{ xs: 8 }}>
                                    <Typography variant='subtitle1' color='white' align='center' p={1} ml={4} mr={-4}>
                                        Weekly average flights per day worldwide
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container alignItems="center">
                                <Grid size={{ xs: 2 }} ml={2}>
                                    <Typography variant='h5' color='#A2D6F8' align='center' sx={{ fontWeight: 'bold' }} className='text-h2' p={1}>+85%</Typography>
                                </Grid>
                                <Grid size={{ xs: 8 }}>
                                    <Typography variant='subtitle1' color='white' align='center' p={1} ml={4} mr={-4}>
                                        Of all data generated globally is considered unstructured
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container alignItems="center">
                                <Grid size={{ xs: 2 }} ml={2}>
                                    <Typography variant='h5' color='#A2D6F8' align='center' sx={{ fontWeight: 'bold' }} className='text-h2' p={1}> 2.5 quintillion</Typography>
                                </Grid>
                                <Grid size={{ xs: 8 }}>
                                    <Typography variant='subtitle1' color='white' align='center' p={1} ml={4} mr={-4}>
                                        Bytes worth of data are generated each day
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>


                    </Grid>
                </Grid>

                {/* Último párrafo */}
                <Grid size={{ xs: 12 }} mt={2}>
                    <Box p={2}>
                        <Typography variant='h5' color="#DDDED9" align='justify' className='text-h4'>
                            ODS brings together multiple decades of knowledge in the
                            aerospace industry and deep expertise in technology to
                            create a data platform that serves as Operational Data
                            Storage for airline data, supporting Digital Channels, Big Data,
                            and Analytics platforms to consolidate all data and support
                            current analysis and reporting needs.
                        </Typography>
                    </Box>
                </Grid>

                <Grid size={{ xs: 12 }} >
                    {/* Fila 1 */}
                    <Grid container spacing={2} alignItems="center" size={{ xs: 12 }} paddingRight={2}>
                        <Grid size={{ xs: 3 }} display="flex" justifyContent="center">
                            <Box
                                component="img"
                                src={Icon1}
                                alt="Icon 1"
                                className="icon-image"
                                sx={{ width: '130px', height: 'auto' }}
                            />
                        </Grid>
                        <Grid size={{ xs: 9 }}>
                            <Typography variant="h5" color="white" className="text-h4" align="left">
                                Ingestion
                            </Typography>
                            <Typography variant="h6" color="#DDDED9" className="text-h5" align="justify" pt={1}>
                                Allows for data in different formats and delivery channels with fewer restrictions. The design principles combine both operational and analytical needs whereby the same data feeds populate both the data lake and operational data store in a historic and auditable way
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Fila 2 */}
                    <Grid container pt={4} spacing={2} alignItems="center" size={{ xs: 12 }} paddingRight={2}>
                        <Grid size={{ xs: 3 }} display="flex" justifyContent="center">
                            <Box
                                component="img"
                                src={Icon2}
                                alt="Icon 2"
                                className="icon-image"
                                sx={{ width: '130px', height: 'auto' }}
                            />
                        </Grid>
                        <Grid size={{ xs: 9 }}>
                            <Typography variant="h5" color="white" className="text-h4" align="left">
                                Processing & transformation
                            </Typography>
                            <Typography variant="h6" color="#DDDED9" className="text-h5" align="justify" pt={1}>
                                Add new ways of data enrichment that will add greater value to the data
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Fila 3 */}
                    <Grid container spacing={2} pt={4} alignItems="center" size={{ xs: 12 }} paddingRight={2}>
                        <Grid size={{ xs: 3 }} display="flex" justifyContent="center">
                            <Box
                                component="img"
                                src={Icon3}
                                alt="Icon 3"
                                className="icon-image"
                                sx={{ width: '130px', height: 'auto' }}
                            />
                        </Grid>
                        <Grid size={{ xs: 9 }}>
                            <Typography variant="h5" color="white" className="text-h4" align="left">
                                Delivery
                            </Typography>
                            <Typography variant="h6" color="#DDDED9" className="text-h5" align="justify" pt={1}>
                                Add new ways of delivering data to the client’s systems (Data Lake access sharing, API connectivity) all in a controlled way with the Airline admins having the option to manage each delivery channel directly
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Fila 4 */}
                    <Grid container spacing={2} pt={4} alignItems="center" size={{ xs: 12 }} paddingRight={2} marginBottom={5}>
                        <Grid size={{ xs: 3 }} display="flex" justifyContent="center">
                            <Box
                                component="img"
                                src={Icon4}
                                alt="Icon 4"
                                className="icon-image"
                                sx={{ width: '130px', height: 'auto' }}
                            />
                        </Grid>
                        <Grid size={{ xs: 9 }}>
                            <Typography variant="h5" color="white" className="text-h4" align="left">
                                Security
                            </Typography>
                            <Typography variant="h6" color="#DDDED9" className="text-h5" align="justify" pt={1}>
                                Single sign-on and data sharing rule / role-based access. Some core functions of our product are cybersecurity, continuous backup, data availability, Cloud Watch and Auditability.
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid >
        </Grid >
    )
}
